import React, { useState } from 'react';
import { FaTimes, FaSearch, FaCheckSquare, FaSquare } from 'react-icons/fa';

function MediaTypesDropdown({ onClose, selectedMediaTypes = [], onMediaTypeChange, allMediaTypes = [] }) {
  const [searchTerm, setSearchTerm] = useState('');

  // Filter media types by search
  const filteredMediaTypes = ['All Media Type', ...allMediaTypes].filter(type =>
    type.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle checkbox click
  const handleCheckboxClick = (type) => {
    if (type === 'All Media Type') {
      onMediaTypeChange(['All Media Type']);
    } else {
      let newSelection = selectedMediaTypes.includes(type)
        ? selectedMediaTypes.filter(t => t !== type)
        : [...selectedMediaTypes.filter(t => t !== 'All Media Type'), type];
      onMediaTypeChange(newSelection);
    }
  };

  return (
    <div className="media-types-dropdown">
      <div className="dropdown-header">
        <h3>Media Type</h3>
        <FaTimes className="close-icon" onClick={onClose} style={{ cursor: 'pointer' }}/>
      </div>
      <div className="dropdown-content">
        <div className="active-filters-summary">
          {selectedMediaTypes.length === 0 || selectedMediaTypes.includes('All Media Type')
            ? 'No Active Media Type'
            : selectedMediaTypes.join(', ')}
        </div>
        <div className="search-input-container">
          <FaSearch />
          <input
            type="text"
            placeholder="Search Media Type"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="options-list">
          {filteredMediaTypes.map(type => (
            <div
              key={type}
              className={`option-item ${selectedMediaTypes.includes(type) ? 'selected' : ''}`}
              onClick={() => handleCheckboxClick(type)}
            >
              <div className="checkbox-container">
                {selectedMediaTypes.includes(type)
                  ? <FaCheckSquare color="blue" />
                  : <FaSquare />}
              </div>
              <span>{type}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MediaTypesDropdown; 